import { ApplicationOwner, CreateOwnerRequest, UpdateOwnerRequest, ProductSetting } from '../types/owner';
import client from './client';

export class OwnerAPIError extends Error {
  constructor(message: string, public status: number) {
    super(message);
    this.name = 'OwnerAPIError';
  }
}

// オーナー管理API
export const ownerAPI = {
  // 現在のユーザーのオーナー情報を取得
  async getMyOwner(): Promise<ApplicationOwner> {
    try {
      const response = await client.get('/api/my-owner');
      return response.data;
    } catch (error: any) {
      throw new OwnerAPIError(
        error.response?.data?.error || 'オーナー情報の取得に失敗しました',
        error.response?.status || 500
      );
    }
  },

  // オーナー情報を作成
  async createOwner(data: CreateOwnerRequest): Promise<ApplicationOwner> {
    try {
      const response = await client.post('/api/my-owner', data);
      return response.data;
    } catch (error: any) {
      throw new OwnerAPIError(
        error.response?.data?.error || 'オーナー作成に失敗しました',
        error.response?.status || 500
      );
    }
  },

  // オーナー情報を更新
  async updateOwner(data: UpdateOwnerRequest): Promise<{ message: string }> {
    try {
      const response = await client.put('/api/my-owner', data);
      return response.data;
    } catch (error: any) {
      throw new OwnerAPIError(
        error.response?.data?.error || 'オーナー更新に失敗しました',
        error.response?.status || 500
      );
    }
  },
};

// サブスクライト商品設定API
export const subscriptAPIV2 = {
  // 商品設定一覧を取得
  async getProductSettings(): Promise<ProductSetting[]> {
    try {
      const response = await client.get('/api/subsclight/product-settings');
      return response.data;
    } catch (error: any) {
      throw new OwnerAPIError(
        error.response?.data?.error || '商品設定の取得に失敗しました',
        error.response?.status || 500
      );
    }
  },

  // 商品設定詳細を取得
  async getProductSetting(id: number): Promise<ProductSetting> {
    try {
      const response = await client.get(`/api/subsclight/product-settings/${id}`);
      return response.data;
    } catch (error: any) {
      throw new OwnerAPIError(
        error.response?.data?.error || '商品設定の取得に失敗しました',
        error.response?.status || 500
      );
    }
  },
};